import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputUse", "onChange", "onOpenChange", "options", "resolver", "value", "uiFormControlProps", "multi"];
import { List } from 'immutable';
import { useCallback, useMemo } from 'react';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { getTransferableProps } from './filterInputProps';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
// This component serves as an interface to reference resolvers lite. THe select
// component it provides only supports arrays so we have to check if the options
// in the operator are an Immutable List and if they are convert them to/from a
// JS array.
const FilterOperatorExternalOptionInput = props => {
  const {
      inputUse,
      onChange,
      onOpenChange,
      options,
      resolver,
      value,
      uiFormControlProps,
      multi
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const safeOnChange = useCallback(event => {
    const newValue = multi ? List(event.target.value) : event.target.value;
    onChange(syntheticEvent(newValue));
  }, [onChange, multi]);
  const jsOptions = useMemo(() => options.toArray().map(({
    label,
    value: optionValue
  }) => ({
    text: label,
    value: optionValue
  })), [options]);
  const jsValue = useMemo(() => {
    if (value) {
      if (typeof value.toArray === 'function') {
        return value.toArray();
      }
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === 'string') {
        if (multi) {
          return [value];
        }
        return value;
      }
    }
    return multi ? [] : undefined;
  }, [value, multi]);
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder
  } = transferableProps;
  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const disabled = transferableProps.disabled;
  // @ts-expect-error allows us to avoid spreading props to UIComponents
  const readOnly = transferableProps.readOnly;
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": uiFormControlProps['aria-label'],
    error: uiFormControlProps.error,
    validationMessage: uiFormControlProps.validationMessage,
    children: /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, {
      "data-selenium-test": dataSeleniumTest,
      placeholder: placeholder,
      disabled: disabled,
      readOnly: readOnly,
      multi: multi,
      onChange: safeOnChange,
      onOpenChange: onOpenChange,
      options: jsOptions,
      resolver: resolver,
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      value: jsValue
    })
  });
};
export default FilterOperatorExternalOptionInput;